import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Button, Container, Text, Title} from '../components/@FreeModel';
import {useDispatch} from "react-redux";
import {AppState} from "../db/model";
import axios, {AxiosError, AxiosRequestConfig} from "axios";

enum Status {
  CANCELED = "CANCELED",
  FOUND = "FOUND",
  NOT_FOUND = "NOT_FOUND",
  NOT_SET = "NOT_SET",
}

const LandingPage = (): React.ReactElement => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {applicationID} = useParams();

  const [pageLoaded, setPageLoaded] = useState(false)
  const [status, setStatus] = useState(Status.NOT_SET)

  useEffect(() => {
    (async (): Promise<void> => {
      const axiosConfig: AxiosRequestConfig = {
        url: `/api/applications/${applicationID}`,
      }

      try {
        await axios.request<AppState>(axiosConfig)
        setStatus(Status.FOUND)

      } catch (error) {
        setStatus(Status.NOT_FOUND)
        if (axios.isAxiosError(error)) {
          const axiosError: AxiosError = error;
          if (axiosError.response?.status === 410) {
            setStatus(Status.CANCELED)
          }
        }
        console.log(error)
      }
      setPageLoaded(true)

    })()
  }, [dispatch, applicationID, setPageLoaded]);

  const handleClick = () => {
    if (!pageLoaded) {
      return
    }
    navigate(`/contractors/${applicationID}/steps`)
  };

  return (
    <Container className="landing-page">
      <div className="landing-wrapper">
        <h1 className="emoji">🎉</h1>

        <br/>

        <Title size="xl-xxl" weight="semibold" lineHeight="lg">
          Welcome to Freemodel
        </Title>

        <br/>

        <Text>
          Thank you for your interest in signing up to work with Freemodel!
        </Text>

        <br/>

        <Text>
          To start, you will need to create an account with us. You can do that by either using an existing Google
          account or creating a separate Freemodel account.
        </Text>

        <br/>
        <br/>

        <Button disabled={!pageLoaded} onClick={handleClick}>
          Continue
        </Button>
      </div>

      <Text className="lp-info" color="gray" size="xs" lineHeight="xs">
        Copyright © 2023 Freemodel, Inc. All rights reserved.
      </Text>
    </Container>
  );
};

export default LandingPage;
